export default {
    calculator: null,
    calculatorParameters: null,
    weight: null,
    volume: null,
    fluidRateUnit: null,
    fluidRate: null,
    currentHematocrit: null,
    donorHematocrit: null,
    intendedHematocrit: null,
    animal: 0,

    drugs: [],
    drugsConcentrations: null,
}